(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["superu-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-su-facts-open]');
  if (trigger) {
    const dialog = document.getElementById(trigger.dataset.suFactsOpen);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
      dialog.addEventListener('close', () => trigger.focus(), { once: true });
    }
    return;
  }
  const closeButton = event.target.closest('[data-su-facts-close]');
  if (closeButton) closeButton.closest('dialog').close();
  if (event.target.matches('dialog.su-facts-modal')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();
})();
